import React from 'react';
import './Service.css';

import { Link } from 'react-router-dom';

 

const Service = ({ service }) => {

  // Destructuring props to extract the necessary details for each service
  const { id, image, title, content } = service;

  return (

    <div className='service-item' key={id}>

      <div className='image'>
        <img src={image} alt={title} /> {/* Service image */}
      </div>

      <div className='content'>

        {/* Link to the individual service page */}
        <Link
          to={{ 
            pathname: '/Services/' + title,  // Navigate to the specific service page
          }}
          location = {{service}}  // Passing service details to the linked page
          state= {service}> 
          <h3>{title}</h3> {/* Service Title */}
        </Link>

        <p>{content}</p> {/* Service Description */}

      </div>

    </div>

  );
};

export default Service;